module.exports = __webpack_public_path__ + "img/60-25cda8.png";